(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-lqp]').forEach((section) => {
      if (section.dataset.lqpReady === 'true') return;
      section.dataset.lqpReady = 'true';

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.18 });

      observer.observe(section);
    });
  };

  document.documentElement.classList.add('js');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
